/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {DLSTheme} from '../../types/types';

export const textFieldOverrides = (theme: DLSTheme) => ({
  root : {
    '&:hover' : {
      backgroundColor : 'transparent'
    }
  },
  shrink : {
    fontSize : '14px'
  }
});

export default textFieldOverrides;
